export default "__VITE_ASSET__CIKvGpqd__"